/* Shared AI-draft candidate card used by LessonSuggesterPanel + LoDrafterPanel. */
import { CheckCircle2, Save } from "lucide-react";

export function DraftCard({ draft, index, saved, saving, onSave }) {
  return (
    <div className="tbg-qcard" data-testid={`suggester-draft-${index + 1}`}
      style={{ opacity: saved ? 0.65 : 1, borderColor: saved ? "rgba(61,192,175,0.5)" : "#2a403c" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
        <span className="tbg-qnum">Draft {index + 1}</span>
        {saved ? (
          <span style={{ color: "#3dc0af", font: "700 10px 'JetBrains Mono', monospace",
            letterSpacing: "0.16em", display: "inline-flex", alignItems: "center", gap: 4 }}>
            <CheckCircle2 size={12} /> STAGED AS DRAFT
          </span>
        ) : (
          <button className="tbg-btn" style={{ padding: "5px 12px", background: "#9c6cf8" }}
            onClick={onSave} disabled={saving} data-testid={`suggester-save-${index + 1}`}>
            <Save size={12} /> {saving ? "Saving…" : "Stage as draft"}
          </button>
        )}
      </div>
      <p className="tbg-qtext">{draft.prompt}</p>
      {draft.options.map((opt, idx) => (
        <div key={idx} className={`tbg-qopt${idx === draft.correct_index ? " correct" : ""}`}>
          <strong style={{ marginRight: 6 }}>{String.fromCharCode(65 + idx)}.</strong>{opt}
        </div>
      ))}
      {draft.rationale && (
        <div className="tbg-rationale">
          <strong style={{ color: "#3dc0af", letterSpacing: "0.06em", fontSize: 11, textTransform: "uppercase" }}>Why: </strong>
          {draft.rationale}
        </div>
      )}
    </div>
  );
}
